"use strict";
var React = require("react");
var AddRoleModal = require("./AddRoleModal");
var EditRoleModal = require("./EditRoleModal");
var DeleteRoleModal = require("./DeleteRoleModal");
var CompanyStore = require("../../../stores/CompanyStore");
var Button = require("react-bootstrap").Button;
var clone = require("clone");
var _ = require("underscore");
var CompanyStore = require("../../../stores/CompanyStore");
var CompanyActions = require("../../../actions/CompanyActions");

var RoleItem = React.createClass({
    getInitialState(){
      var roles = _.indexBy(CompanyStore.getState().roles, "id");
      return {
        showEditModal: false,
        showDeleteModal: false,
        showAddModal: false,
        roleMap: roles,
        role: {},
      };
    },
    closeEdit(){
      this.setState({ showEditModal: false });
    },
    openEdit(role){
      this.setState({ showEditModal: true, role: role });
    },
    closeDelete(){
      this.setState({ showDeleteModal: false });
    },
    openDelete(role){
      this.setState({ showDeleteModal: true, role: role });
    },
    closeAdd() {
      this.setState({ showAddModal: false });
    },
    openAdd(role) {
      this.setState({
        role: role,
        showAddModal: true,
      });
    },
    mapIcons: function(tree) {
      return (
        <li key={tree.id}>
          <div className="tree-item">
            <div className="tree-item-name">{tree && tree.name}</div>
            <div className="tree-item-buttons">
              <button className="tree-button" type="button" title="Breyta" onClick={() => this.openEdit(tree)}>
                <span className="md md-mode-edit"/>
              </button>
              <button className="tree-button" type="button" title="Eyða" onClick={() => this.openDelete(tree)}>
                <span className="md md-delete"/>
              </button>
            </div>
          </div>
        </li>
      );
    },
    render: function() {
        return (
          <ul className="first-ul">
            <AddRoleModal parent={this.state.role} show={this.state.showAddModal} onHide={this.closeAdd} />
            <EditRoleModal role={this.state.role} show={this.state.showEditModal} onHide={this.closeEdit} />
            <DeleteRoleModal role={this.state.role} show={this.state.showDeleteModal} onHide={this.closeDelete} />
            {this.props.tree.map((treeItem) => {
              return this.mapIcons(treeItem);
            })}
          </ul>
        );
    }
});

var RolesTab = React.createClass({
  getInitialState() {
    var storeState = CompanyStore.getState();
    var roles = storeState.roles;
    var tree = [];
    var map = {};
    var node;
    for (var i = 0; i < roles.length; i++) {
      node = roles[i];
      node.children = [];
      map[node.id] = i; // use map to look-up the parents
      if (node.parent === null) {
        // Add parent
        tree.push(node);
      } else {
        // Add children to the referenced flat array.
        roles[map[node.parent]].children.push(node);
      }
    }

    return {
      roles: roles,
      showModal: false,
      roleTree: tree
    };
  },
  componentDidMount: function() {
    CompanyStore.listen(this.onChange);
  },
  componentWillUnmount: function() {
    CompanyStore.unlisten(this.onChange);
  },
  onChange: function() {
    this.setState(this.getInitialState());
  },
  close(){
    this.setState({ showModal: false });
  },
  open(){
    this.setState({ showModal: true });
  },
  mapRoles(role) {
    return (
      <RoleItem key={role.id} role={role} tree={this.state.roleTree}/>
    );
  },
  render: function() {
    return(
      <div className="row">
        <div className="settings-header col-xs-12">
            <h3>Hlutverk</h3>
            <AddRoleModal show={this.state.showModal} onHide={this.close}/>
            <Button className="page-scroll btn btn-xl" onClick={this.open}>Bæta við hlutverki</Button>
        </div>
        <div className="settings-body col-xs-12">
          <div className="row">
            <div className="tree-list">
              <RoleItem role={this.state.roleTree[0]} tree={this.state.roleTree} />
            </div>
          </div>
        </div>
      </div>
    );
  }
});

module.exports = RolesTab;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Roles/RolesTab.react.js